<div class="search-box">
  <pos-app-lib-customer-external-search (selectNewCustomer)="selectCustomer($event)"> </pos-app-lib-customer-external-search>
</div>
